
define('app/board/views/playerRankingView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'app/board/collections/pickSummaryCollection',
	'app/board/collections/queueCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	'app/board/models/pickModel',
	'app/board/models/queueItemModel',
	'app/board/util/playerList',
	
	//Templates
	'text!app/board/templates/playerRankingTemplate.html'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		PickSummaryCollection,
		QueueCollection,
		LeagueInstanceModel, 
		DraftStatusModel, 
		PositionColorsModel,
		PickModel,
		QueueItemModel,
		PlayerList, 
		playerRankingHtml){
	var PlayerRankingView = Backbone.View.extend({
		
		initialize: function(options) {
			this.player = options.player;
			this.rankAttr = options.rankAttr;
			this.projCatArr = options.projCatArr;
			this.draftStatus = options.draftStatus;
			this.leagueInstance = options.leagueInstance;
			this.user = options.user;
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.posColors = options.posColors;
			this.queueCollection = options.queueCollection;
			
			_.bindAll(this, 'draftPlayer');
			_.bindAll(this, 'updateBtnVisuals');
			_.bindAll(this, 'addQueueItem');
			
			this.listenTo(this.posColors, 'change', this.updateDraftStatus);
			this.draftStatus.bind("change", this.updateBtnVisuals, this);
			
			this.playerRankingTemplate = _.template(playerRankingHtml.trim());
			
			this.buildEl();
			
			this.$(".rankDraftActions").find('.draftRankedPlayerBtn').on('click', {}, this.draftPlayer);
			this.$(".rankDraftActions").find('.queueRankedPlayerBtn').on('click', {}, this.addQueueItem);
			
			this.listenTo(this.queueCollection, 'add', this.disableQueue);
			this.listenTo(this.queueCollection, 'remove', this.enableQueue);
		},
		
		render: function () {
			
			
			return this;
		},
		
		buildEl: function() {
			var teamAbbr = (this.player.byeWeek && this.player.byeWeek > 0) 
					? '<span>'+this.player.teamAbbr+'<span class="playerRankingBye">('+this.player.byeWeek+')</span></span>' 
					: '<span>'+this.player.teamAbbr+'</span>';
			
			this.setElement($(this.playerRankingTemplate({
				available: this.player.drafted ? 'playerDrafted' : '',
				
				playerName: this.playerNameText(),
				playerPos: this.player.position,
				teamAbbr: teamAbbr})));
			
			var ranksEnabled = this.leagueInstance.get('ranksEnabled');
			var projsEnabled = this.leagueInstance.get('statsEnabled');
			
			if(ranksEnabled) {
				if(this.rankAttr != 'OVRRANK'){
					this.$el.append($('<td>'+ (this.player.attrs[this.rankAttr] ? this.player.attrs[this.rankAttr] : 'N/A')+'</td>'));
					this.$el.append($('<td>'+ (this.player.attrs['OVRRANK'] ? this.player.attrs['OVRRANK'] : 'N/A')+'</td>'));
				} else {
					this.$el.append($('<td>'+ (this.player.attrs['OVRRANK'] ? this.player.attrs['OVRRANK'] : 'N/A')+'</td>'));
				}
			}
			
			if(projsEnabled) {
				for(var i=0; i<this.projCatArr.length; i++){
					var cat = this.projCatArr[i];
					var projStats = this.player.projectedStats;
					var sourceMap = projStats ? projStats[cat] : null;
					var proj = sourceMap ? sourceMap['CONSENSUS'] : null;
					
					this.$el.append($('<td>'+ (proj ? parseFloat(Math.round(proj * 100) / 100).toFixed(1) : '0.0')+'</td>'));
				}
			}
			
			if(!ranksEnabled && !projsEnabled){
				this.$el.append($('<td>&nbsp;</td>'));
			}
			
			var curFantTeamId = -1;				
			if(this.leagueInstance.get('draftType') == 'AUCTION') {
				if(!this.draftStatus.get('auctionBidding')){
					curFantTeamId = this.draftStatus.get('draftingTeamId');
				}
			} else {
				var pickSum = this.pickSummaryCollection.get(
						this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound'))
						);
				
				if(pickSum){
					curFantTeamId = pickSum.get('fantasyTeamId');
				}
			}
			
			if(curFantTeamId > 0){
				var teamOwner = this.leagueInstance.getTeamOwner(curFantTeamId);
				var userName = this.user.get('userName');
				var isAssistant = this.leagueInstance.isAssistant(userName);
				
				//Change color of button for commish
				if(isAssistant && userName.toUpperCase() != teamOwner.toUpperCase()){
					this.$el.find('.draftRankedPlayerBtn').removeClass('btn-success');
					this.$el.find('.draftRankedPlayerBtn').addClass('btn-info');
				} else {
					this.$el.find('.draftRankedPlayerBtn').removeClass('btn-info');
					this.$el.find('.draftRankedPlayerBtn').addClass('btn-success');
				}
			}
			
			if(this.queueCollection.get(this.player.draftablePlayerId)){
				this.$el.find('.queueRankedPlayerBtn').css({'display': 'none'});
			} else {
				this.$el.find('.queueRankedPlayerBtn').css({'display': ''});
			}
			
			this.updateDraftStatus();
			this.updateBtnVisuals();
		},
		
		enableQueue: function(queueItem) {
			if(queueItem.get('id') == this.player.draftablePlayerId){
				this.$el.find('.queueRankedPlayerBtn').css({'display': ''});
			}
		},
		
		disableQueue: function(queueItem) {
			if(queueItem.get('id') == this.player.draftablePlayerId){
				this.$el.find('.queueRankedPlayerBtn').css({'display': 'none'});
			}
		},
		
		addQueueItem: function() {
			if(!this.queueCollection.get(this.player.draftablePlayerId)){	
				var newQueueItem = new QueueItemModel({
					id: this.player.draftablePlayerId,
					playerPos: this.player.position,
					byeWeek: this.player.byeWeek,
					teamAbbr: this.player.teamAbbr,
					fName: this.player.firstName,
					lName: this.player.lastName,});
				this.queueCollection.add(newQueueItem);
			}
		},
		
		playerNameText: function() {
			var dispName = this.player.lastName;
			
			if(this.player.firstName){
				dispName += ', ' + this.player.firstName;
			}
			
			return dispName; 
		},
		
		draftPlayer: function() {			
			var round = this.draftStatus.get('round');
			var posInRound = this.draftStatus.get('posInRound');
			var fantTeamId = this.draftStatus.get('draftingTeamId');
			var keeper = false;
			var autoDrafted = false;
			
			if(this.leagueInstance.get('id') == 70119 && this.draftStatus.get('round') <= 6 && this.player.drafted){
				var dataObj = {
						firstName: this.player.firstName,
						lastName: this.player.lastName,
						teamAbbr: this.player.teamAbbr,
						position: this.player.position,
						fantasyTeamId: fantTeamId,
						round: round,
						posInRound: posInRound,
						keeper: keeper};
				
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : '/draftapp/leagues/' 
						+ this.leagueInstance.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueInstance.get('id')
						+ '/picks/new',
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : JSON.stringify(dataObj, null, 2),
					success: this.successCallback,
					error: this.errorCallback
				});
				
				return this;
			}
			
			//var pickSum = this.pickSummaryCollection.get(this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound')));
			//var value = pickSum.get('ovrPickNum');
			
			//Nominating Player
			//if(this.leagueInstance.get('draftType') == 'AUCTION') {
			//	value = 0;
			//}
			
			var newPick = new PickModel({
				leagueId : this.leagueInstance.get('leagueId'),
				leagueInstanceId : this.leagueInstance.get('id'),
				fantasyTeamId : fantTeamId,
				draftablePlayerId : this.player.draftablePlayerId,
				//value : value,
				round : round,
				posInRound: posInRound,
				keeper : keeper,
				autoDrafted : autoDrafted});
			
			newPick.save();
		},
		
		updateDraftStatus: function() {
			if(this.player.drafted){
				this.$el.find('td').css({'background-color': ''});
				this.$el.addClass('playerDrafted');
			} else {
				var color = this.posColors.retrievePosColor(this.player.position);
				this.$el.removeClass('playerDrafted');
				this.$el.find('td').css({'background-color': color});
			}
			
			if(this.leagueInstance.get('id') == 70119 && this.draftStatus.get('round') <= 6 && this.player.drafted){
				var color = this.posColors.retrievePosColor(this.player.position);
				this.$el.removeClass('playerDrafted');
				this.$el.find('td').css({'background-color': color});
				this.$el.find('.draftRankedPlayerBtn').html('C');
			}			
		},
		
		updateBtnVisuals: function() {
			var curFantTeamId = -1;				
			if(this.leagueInstance.get('draftType') == 'AUCTION') {
				if(!this.draftStatus.get('auctionBidding')){
					curFantTeamId = this.draftStatus.get('draftingTeamId');
				}
			} else {
				var pickSum = this.pickSummaryCollection.get(this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound')));
				
				if(pickSum){
					curFantTeamId = this.leagueInstance.getTeamOwner(pickSum.get('fantasyTeamId'));
				}
			}
			
			
			if(this.leagueInstance.get('draftStatus') == 'STARTED' && curFantTeamId > 0){
				var fantTeamId = curFantTeamId;
				var allowedPositions = this.draftStatus.get('allowedPositions')[fantTeamId];
				
				if(_.intersection(allowedPositions,this.player.position.split(',')).length > 0){
					this.$el.find('.draftRankedPlayerBtn').css({'display': ''});
				} else {
					this.$el.find('.draftRankedPlayerBtn').css({'display': 'none'});
				}
			} else {
				this.$el.find('.draftRankedPlayerBtn').css({'display': ''});
			}			
		},
		
		destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	return PlayerRankingView;  
});